import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import loaderGif from "../../../../../assets/images/loader.gif";
import { Tooltip } from 'react-tooltip';
import '../suggestions.css';
import button from "../../../../button.module.css";

const SuggestionsList = ({ tableData, getSuggestion , onSort, updateStatus, search, loader , selectedSuggestionRole}) => {
//const SuggestionsList = ({ tableData, onDeleteSuggestion, addsubSuggestion, getSuggestion, changePw, onSort, updateStatus, delSuggestion, search, loader , selectedSuggestionRole}) => {
    const navigate = useNavigate();
    const [expandedRows, setExpandedRows] = useState([]); // State to track expanded rows
    const [selectedSuggestion, setSelectedSuggestion] = useState(null);

    const suggestionListData = (id) => {
        getSuggestion(id);
    };



    const handleSort = (column) => {
        onSort(column);
    };


    
    useEffect(() => {
        setExpandedRows([]);
      }, [selectedSuggestionRole, search]);
      

    const toggleRow = (index) => {
        if (expandedRows.includes(index)) {
            setExpandedRows(expandedRows.filter((row) => row !== index));
        } else {
            setExpandedRows([...expandedRows, index]);
        }
    };


    return (
        <>
            <div className="table-responsive custom-table">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th className="srno">Sr. No.</th>
                            <th className="partner">Category </th>
                            <th className='deal-name' style={{ width: '900px' }}>Suggestion </th>
                            <th className="status">Status </th>
                            <th className="action">Action </th>
                        </tr>
                    </thead>

                    {!loader ? (
                        <tbody>
                            {tableData && tableData.length > 0 ? (
                                tableData?.map((item, i) => (
                                    <React.Fragment key={i}>
                                        {/* Main Row */}
                                        <tr>
                                            <td>{i + 1}</td>
                                            <td className="action">{item?.category_name}</td>
                                            <td style={{ whiteSpace: 'pre-line' }}>{item?.suggestion?.trim() || "—"}</td>
                                            <td className="text-center status">
                                                <label className="custom-switch">
                                                    <input 
                                                        type="checkbox" 
                                                        checked={item?.status === 1} 
                                                        onClick={() => updateStatus(item.id, item.status === 1 ? 0 : 1)} 
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                            </td>
                                            <td className="text-center status">
                                                <div className="table-icons">
                                                    <i className="fa-regular fa-pen-to-square green" onClick={() => suggestionListData(item?.id)}></i>
                                                </div>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" className="text-center">No Data Found</td>
                                </tr>
                            )}
                        </tbody>
                    ) : (
                        <div className={`loader ${loader ? 'show' : ''}`}>
                            <label>
                                <img src={loaderGif} alt="Loading..." />
                            </label>
                        </div>
                    )}
                </table>
            </div>

            <Tooltip id="my-tooltip-inline" place="top" className="custom-tooltip" />

            {/* 🆕 Login Modal */}
          

        </>
    );
};

export default SuggestionsList;
